module.exports = __webpack_public_path__ + "media/escudos/logo_muni_san_bartolo-14f1c1cc.png";